import { getColor, getSize } from "views/resources/theme";
import styled from "styled-components";

export const InputWrapper = styled.div`
	margin: 0;
	padding: 0 ${getSize("s")};
	border: 0;
	width: 90%;
	box-sizing: border-box;
	font-size: ${getSize("sm")};
	display: inline-block;

	input {
		outline: none;
		border: none;
		width: 100%;
		height: 60px;
		padding: 0px 5px;

		position: relative;
		font-size: 0.9rem;
		box-sizing: border-box;
	}
`;

export const SearchBorder = styled.div`
	margin: 5px ${getSize("s")};
	padding: 2px ${getSize("s")};
	box-model: border-box;
	.ripple {
		display: inline-block;
	}
`;

export const Wrapper = styled.div`
	background-color: ${getColor("bg")};
	color: ${getColor("fg")};
	align-items: center;
	border: 1px solid #dedede;
	margin: 0;
	border-radius: ${getSize("s")};
`;

export const FormWrapper = styled.form`
	padding: 5px;
	background: ${getColor("bg")};
	margin: 0 ${getSize("s")} ${getSize("s")};
	border-radius: ${getSize("s")};
`;
